const ArticleData = [
  {
    title: "Integrating FlashTalking library via code",
    url: "/article/api-ft", 
    category: "Creative",
  },
  {
    title: "Dynamic creative submission guidelines",
    url: "/article/dynamic-creative-guidelines",
    category: "Creative",
  }
];

export default ArticleData;
